/** @internal */
const HASH_PREFIX = 'f';
/** @internal */

const SEQUENCE_HASH_LENGTH = 7;
/** @internal */

const SEQUENCE_PREFIX = '___';
/** @internal */

const DEFINITION_LOOKUP_TABLE = {}; // indexes for values in LookupItem tuple

/** @internal */

const LOOKUP_DEFINITIONS_INDEX = 0;
/** @internal */

const LOOKUP_DIR_INDEX = 1;

export { DEFINITION_LOOKUP_TABLE, HASH_PREFIX, LOOKUP_DEFINITIONS_INDEX, LOOKUP_DIR_INDEX, SEQUENCE_HASH_LENGTH, SEQUENCE_PREFIX };
